import { columns } from './properties/columns';
import { columnsForStuckBunk } from './properties/columnsForStuckBunk';
import { filter } from './properties/filter';
import { model } from './properties/model';
import { sort } from './../properties/sort';
import { pagination } from './../properties/pagination';

export const state = {
  list: [],
  expire_amount: 0,
  inventory: [],
  model: JSON.parse(JSON.stringify(model)),
  columns: columns,
  columnsForStuckBunk: columnsForStuckBunk,
  filter,
  pagination: JSON.parse(JSON.stringify(pagination)),
  sort: JSON.parse(JSON.stringify(sort)),
};